/**
 * Created by XUQIANG on 2017/5/23.
 */
import React from 'react';
import { Menu, Icon } from 'antd';
import { PATH_HOME, PATHS } from '../../utils/constants';
import { routerRedux } from 'dva/router';
import './Menu.less';
import menuTitleImg from '../../assets/menutitle.png';
import { connect } from 'dva';

const SubMenu = Menu.SubMenu;
const MenuItem = Menu.Item;
const getMenuLogo = key => {
  if(key == 'yuyue'){
    return require('../../assets/menuimg/yuyue.png');
  }else if(key == 'my'){
    return require('../../assets/menuimg/my.png');
  }else if(key == 'shenpi'){
    return require('../../assets/menuimg/shenpi.png');
  }else if(key == 'huabanzhanbaniconyuanchuang'){
    return require('../../assets/menuimg/zhanbanjiankong.png');
  }else if(key == 'setting'){
    return require('../../assets/menuimg/setting.png');
  }else if(key == 'iconfontxinxishezhi'){
    return require('../../assets/menuimg/qiyexinxi.png');
  }else if(key == 'selfinfo'){
    return require('../../assets/menuimg/selfinfo.png');
  }else if(key == 'report'){
    return require('../../assets/menuimg/report.png');
  }
  return  null;
};
const NavMenu = ({ menuData = {}, dispatch, location, intl }) => {
  const { menus = [], minitorServer = '' } = menuData;
  const { pathname, query } = location;

  const selectedKeys = [pathname];
  if (pathname.indexOf(PATHS.account) !== -1) {
    selectedKeys.push(PATHS.account);
  }
  if (pathname.indexOf(PATHS.audit) !== -1) {
    selectedKeys.push(PATHS.audit);
  }
  if (pathname.indexOf(PATHS.controlBoard) !== -1) {
    selectedKeys.push(PATHS.controlBoard);
  }

  if (pathname.indexOf(PATHS.personalConfig) !== -1) {
    selectedKeys.push(PATHS.personalConfig);
  }

  if (pathname === PATHS.meetingInfo) {
    const { meetingId } = query;
    selectedKeys.push(meetingId ? PATHS.list : PATHS.meeting);
  }
  if (pathname.indexOf('meetingControl') > -1) {
    selectedKeys.push(PATHS.list);
  }
  return (
    <div className="nav-menu" style={menuData.inlineCollapsed?{width:'65px'}:{}}>
      <div className="nav-menu-header">
        <img style={{}} onClick={()=>{
          // dispatch({type:"menu/update",payload:{inlineCollapsed: !menuData.inlineCollapsed}})
        }} src={menuTitleImg} width={14} height={14}/>
      </div>
      <div className="nav-menu-div">       
        <Menu
          defaultSelectedKeys={[PATHS.account]}
          selectedKeys={selectedKeys}
          onClick={({key}) => {
            dispatch(routerRedux.push(key));
          }}
          mode="inline"
          inlineCollapsed={false}
        >
          {menus &&
            menus.status === 0 &&
            menus.data &&
            menus.data.map(menu => {
              if(`${PATH_HOME}${menu.url}` === PATHS.controlBoard && !minitorServer){
              } else {
                return `${PATH_HOME}${menu.url}` === PATHS.report ? (
                  <SubMenu
                    key={`${PATH_HOME}${menu.url}`}
                    title={
                      <span>
                            <Icon><img className="menu-title-img" src={getMenuLogo(menu.image)}/></Icon>
                            <span>{intl.formatMessage({id: menu.name})}</span>
                    </span>
                    }
                  >
                    {menu.children &&
                    menu.children.map(childMenu => {
                      return (
                        <MenuItem
                          key={`${PATH_HOME}${childMenu.url}`}
                          title={intl.formatMessage({ id: childMenu.name })}
                        >
                          <i className={'iconfont icon-' + childMenu.image} />
                          <span>{intl.formatMessage({ id: childMenu.name })}</span>
                        </MenuItem>
                      );
                    })}
                  </SubMenu>
                ) : (
                  <MenuItem key={`${PATH_HOME}${menu.url}`} title={intl.formatMessage({ id: menu.name })}>
                  <Icon><img className="menu-title-img" src={getMenuLogo(menu.image)}/></Icon>
                    <span>{intl.formatMessage({ id: menu.name })}</span>
                  </MenuItem>
                );
              }
            })}
        </Menu>
      </div>
    </div>
  );
};



export default connect(state=>{
  console.log("state111111",state);
  return {
    inlineCollapsed: state.menu.inlineCollapsed
  }
})(NavMenu);



// WEBPACK FOOTER //
// ./src/components/layout/Menu.js